import { z } from '@faceup/validation'

// The address an invitation or reminder went to is not repeated here — it belongs to the invite
// the entry hangs off, and duplicating it would let the two drift apart
export const disclosureSubmissionAuditLogPayloadSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('InvitationSent') }),
  z.object({ type: z.literal('ReminderSent') }),
])

export type DisclosureSubmissionAuditLogPayload = z.infer<
  typeof disclosureSubmissionAuditLogPayloadSchema
>

export const disclosureSubmissionAuditLogTypeEnum = z.enum(
  disclosureSubmissionAuditLogPayloadSchema.options.map(option => option.shape.type.value)
).enum
